import get from 'lodash/get';
import memoize from 'lodash/memoize';

export const initialState = {
  lang: 'en',
  translations: {},
};

export const languageSelector = (state = initialState) => state.lang;
const translationSelector = (state = initialState) => state.translations[languageSelector(state)] || {};

export const getLanguage = languageSelector;

export const getLanguages = (state = initialState) => state.languages || [];

const getWithDefault = (obj, key) => get(obj, key) || key || '';

const translate = (state = initialState, key) => {
  const translations = translationSelector(state);
  return Array.isArray(key)
    ? key.map(k => getWithDefault(translations, k))
    : getWithDefault(translations, key);
};
const translateResolver = (state, keys) => [].concat(
  typeof keys,
  keys,
  languageSelector(state),
  Object.keys(translationSelector(state),
)).join('');

export const t = memoize(translate, translateResolver);



// WEBPACK FOOTER //
// ./src/store/lang/selectors.js